import { IonAlert, IonBackButton, IonButton, IonButtons, IonChip, IonHeader, IonIcon, IonMenuButton, IonText, IonToggle, IonToolbar, useIonAlert } from '@ionic/react'
import { useUIStore } from './stateManagement/UIZustand';
import { useTreeStore } from './stateManagement/treeZustand';
import { _SMALL_SCREEN_WIDTH, _clipboardCards, _dict, _freeCards, _rootName } from './constants';
import { useUserStore } from './stateManagement/userZustand';
import { clipboard, close, help, home, link, open, searchCircle, swapHorizontal } from 'ionicons/icons';
import { useURLStore } from './stateManagement/URLZustand';
import { useGlobalStore } from './stateManagement/globalZustand';
import { logMe } from '../foo/user';
import { goToPayment } from './payments';
import { copySublistToPositions, updict } from './foo';
import { useHistory } from 'react-router';

//interface
interface CommonHeaderProps {
  extraJSX?: JSX.Element;
}

const CommonHeader: React.FC<CommonHeaderProps> = ({ extraJSX }) => {

  const { setIsPasteConfirmOpen,
    windowSize, setIsShareModalOpen, isSidebarVisible,
    setIsSidebarVisible, isSidebarHorizontal, setIsSidebarHorizontal, isPasteConfirmOpen, selectedLabels,
    resetSelectedLabels } = useUIStore();
  const { nodesCount, nodes, importPecs, pasteNodes, setNodes } = useTreeStore();
  const { isSubscribed, userUniqueId, userEmail } = useUserStore();

  const { URLVars, visibleLabels, isHomePage, isHelpPage, isCardsPage, getURLTo, isTaskPage } = useURLStore();
  const [presentAlert] = useIonAlert();
  const { clipboardCards, lang, clipboardPecs, isParentMode, setIsParentMode, setHomeNodePath, setClipboardCards, setClipboardPecs } = useGlobalStore();




  const FreeQuotaAlert = () => presentAlert({
    header: _dict.freeQuotaHeader[lang],
    message: _dict.freeQuotaMsg[lang],
    buttons: [{
      text: _dict.freeQuotaPremiumBtnText[lang],
      handler: async () => { logMe("click_premium", { from: "freeQuotaAlert" }); goToPayment(userUniqueId) }
    }]
  });

  const history = useHistory();
  const pasteButton = URLVars.section === "talk" && (clipboardCards.length > 0 || Object.keys(clipboardPecs).length > 0) && isParentMode === true ?
    <button onClick={() => { setIsPasteConfirmOpen(true); }}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        //orange color like the "warning" color of ionic
        backgroundColor: '#007ea7',
        color: 'white',
        fontSize: '16px',
        padding: '10px 20px',
        borderRadius: '10px',
        marginRight: "1px"

      }}
    >
      <IonIcon size="small" icon={clipboard} />
      {windowSize.width > _SMALL_SCREEN_WIDTH ? _dict.pasteHere[lang] : null}

    </button>
    : null;

  const shareButton = URLVars.section === "talk" && (clipboardCards.length === 0 && Object.keys(clipboardPecs).length === 0) && isParentMode === true && nodes[URLVars.nodePath!]?.length > 0 ?
    <button onClick={() => { logMe("click_shareButton", {}); setIsShareModalOpen(true) }}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        // light color like the "light" color of ionic
        backgroundColor: '#f4f5f8',
        color: 'black',
        boxShadow: '0px 0px 2px 0px rgba(0,0,0,0.60)',
        fontSize: '16px',
        padding: '10px 20px',
        borderRadius: '10px',
        marginRight: "1px"
      }}
    >

      <IonIcon size="small" icon={link} style={{ marginRight: '8px' }} />
      {windowSize.width > _SMALL_SCREEN_WIDTH ? _dict.share[lang] : null}
    </button>
    : null;

  const loginChip = (userEmail === "" || userEmail === undefined || userEmail === null) ?
    <IonChip onClick={() => { history.push("/login"); }}>{_dict.clickHereToLogin[lang]}</IonChip>
    : null;
  // Check if menu if open
  const showSideBarIcon = <IonButton
    expand='full'
    color="dark"
    onClick={() => {
      // cycle: hide -> show -> vertical -> horizontal
      if (isSidebarVisible === false) {
        setIsSidebarVisible(true);
        setIsSidebarHorizontal(false); // Ensure sidebar is vertical when shown
      } else if (isSidebarHorizontal === false) {
        setIsSidebarHorizontal(true);
      } else {
        setIsSidebarVisible(false);
      }
    }}

    style={{
      fontSize: '24px',
      padding: '10px 20px',
      //position: 'relative',
      zIndex: 9999,
      margin: 0


    }}
  >
    <IonIcon icon={
      isSidebarVisible === true && isSidebarHorizontal === false ? swapHorizontal :
      isSidebarVisible === true && isSidebarHorizontal === true ? close :
      open}

      slot="start"
      />
    <IonText>{isParentMode === true && isCardsPage() ? _dict.options[lang] : _dict.sentence[lang]}</IonText>
  </IonButton>


    ;



  const cardsSizeSection = <IonButtons slot="end">


    <IonButton key="scs" size="small" onClick={
      () => {
        logMe("click_stories", {});
        history.push(getURLTo().stories());
      }
    }>
      <IonIcon icon={searchCircle} />
      {_dict.search[lang]}
    </IonButton>
    <IonButton key="sch" size="small" onClick={
      () => {
        logMe("click_help", {});
        history.push(getURLTo().help());
      }
    }>
      <IonIcon icon={help} />
      {_dict.ask[lang]}
    </IonButton>
    <IonButton key="hpb" size="small" fill="outline"
      style={{ "--color": "#007EA7" }}
      color={isHomePage() ? undefined : "dark"}
      onClick={() => setHomeNodePath()}>
      <IonIcon icon={home} />{_dict.startHere[lang]}{isHomePage() ? '' : '?'}
    </IonButton>
  </IonButtons>;
  /*
   <IonButton key="sup" size="small"
   fill={cardSizeMultiplier > _cardSizeMultiplier ? "outline":"solid"}
   color={cardSizeMultiplier > _cardSizeMultiplier ? "medium":"light"}
   onClick={() => increaseCardSizeMultiplier()}>
     <IonIcon icon={expand} />{_dict.magnify[lang]}
   </IonButton>
   <IonButton key="dwn"
   fill={cardSizeMultiplier < _cardSizeMultiplier ? "outline":"solid"}
   color={cardSizeMultiplier < _cardSizeMultiplier ? "medium":"light"}
   size="small" onClick={() => decreaseCardSizeMultiplier()}>
     <IonIcon icon={contract} />{_dict.reduce[lang]}
   </IonButton>
   */




  const pasteBeforeSelectedCards = {
    text: Object.keys(selectedLabels).length > 0 ? _dict.pasteBeforeSelectedCards[lang] : _dict.pasteInCurrentBranch[lang],
    handler: () => {
      if (nodesCount > _freeCards && isSubscribed === false) {
        FreeQuotaAlert();
      } else {
        let pastedCardsList: string[];
        if (clipboardPecs.nodes !== undefined) {
          importPecs(clipboardPecs, URLVars.nodePath!, Object.keys(selectedLabels));
          pastedCardsList = Object.values(clipboardPecs.nodes).flat() as string[];
        } else {
          // first add cards to the end of current branch
          pasteNodes(clipboardCards, URLVars.clipboardFromPath!, URLVars.nodePath!, [], false);
          pastedCardsList = clipboardCards;
        }
        // then reorder cards according to selectedLabels positions but before that turn clipboardPecs to clipboardCards
        let reordered = nodes[URLVars.nodePath!] !== undefined ? [...nodes[URLVars.nodePath!]] : [];
        reordered = copySublistToPositions(reordered, pastedCardsList, Object.values(selectedLabels).flat());
        setNodes(updict(nodes, URLVars.nodePath!, reordered));
        setClipboardCards(_clipboardCards);
        setClipboardPecs({});
        resetSelectedLabels();

      }


    },
  };

  const pasteInsideSelectedCards = {
    text: Object.keys(selectedLabels).length > 0 ? _dict.pasteInsideSelectedCards[lang] : _dict.pasteInCurrentBranch[lang],
    handler: () => {
      if (nodesCount > _freeCards && isSubscribed === false) {
        FreeQuotaAlert();
      } else {
        if (clipboardPecs.nodes !== undefined) {
          importPecs(clipboardPecs, URLVars.nodePath!, Object.keys(selectedLabels));
        } else {
          pasteNodes(clipboardCards, URLVars.clipboardFromPath!, URLVars.nodePath!, Object.keys(selectedLabels), false);
        }
        setClipboardCards(_clipboardCards);
        setClipboardPecs({});
        resetSelectedLabels();
      }
    },
  }

  const dontPaste = {
    text: _dict.dontPaste[lang],
    role: 'cancel',
    cssClass: 'secondary',
    handler: () => {

    },
  };

  const undoCopy = {
    text: _dict.undoCopy[lang],
    handler: () => {
      setClipboardCards(_clipboardCards);
      setClipboardPecs({});
      resetSelectedLabels();
    },
  };

  let allPasteButtons;
  if (Object.keys(selectedLabels).length > 0) {
    allPasteButtons = [pasteBeforeSelectedCards, pasteInsideSelectedCards, dontPaste, undoCopy];
  } else {
    allPasteButtons = [pasteInsideSelectedCards, dontPaste, undoCopy];
  }
  return (
    <IonHeader style={{ padding: "0", margin: "0" }} >

      <IonToolbar style={{ "--background": "#fcfcfc", padding: "0", margin: "0" }}>
        <IonButtons slot="start"  >
          <IonMenuButton style={{ "color": "black" }} className="tourStep0 tourStep3" />
          {isHelpPage() || isTaskPage() ? <IonBackButton defaultHref={
            isTaskPage() ? getURLTo().talkFromCustomNodePath(URLVars.nodePath || _rootName) :
              getURLTo().home()} /> : null}
          {isTaskPage() ? <IonButton size="large" shape="round" onClick={() => {
            history.push(getURLTo().home());
            // Reload
            window.location.reload();
          }}>
            <IonIcon icon={home} />
          </IonButton> : null}
          {pasteButton}{loginChip !== null ? loginChip : shareButton}
          {extraJSX}
          {isParentMode &&
            <IonChip outline={true}><IonToggle
              checked={isParentMode}
              color="warning"
              onIonChange={() => { setIsParentMode(false); }}>
              {windowSize.width > _SMALL_SCREEN_WIDTH && _dict.parentMode[lang]}
            </IonToggle></IonChip>}

        </IonButtons>


        {isParentMode === true && URLVars.section === "talk" && URLVars.nodePath !== "help" && windowSize.width > _SMALL_SCREEN_WIDTH && visibleLabels !== undefined && visibleLabels?.length > 0 ? cardsSizeSection : undefined}
        {!isHelpPage() &&  /*visibleLabels !== undefined && visibleLabels.length > 0 &&*/ <IonButtons slot="end" style={{ padding: "0", margin: "0" }}>{showSideBarIcon}</IonButtons>}

      </IonToolbar>


      <IonAlert
        isOpen={isPasteConfirmOpen}
        onDidDismiss={() => setIsPasteConfirmOpen(false)}
        header={_dict.pasteHere[lang]}
        message={_dict.areYouSureToPasteHere[lang]}
        buttons={allPasteButtons}
      />

    </IonHeader>
  )
}

export default CommonHeader